package com.nonopn.skydome.common.app.pages.dashboard.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.skydome.common.app.pages.dashboard.components.DashboardColors.titleColor
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.widgets.DefaultCard

@Composable
fun InternalCard(
    modifier: Modifier,
    title: String,
    backgroundColor: Color = AppColor.WhiteCream,
    content: @Composable () -> Unit,
) {
    DefaultCard(
        modifier = modifier.clip(RoundedCornerShape(10.dp)),
        backgroundColor = backgroundColor,
        columnModifier = Modifier.padding(15.dp),
    ) {
        Text(
            text = title,
            fontSize = 14.sp,
            color = titleColor,
            fontWeight = FontWeight.Bold
        )

        Spacer(modifier = Modifier.height(16.dp))

        content()
    }
}
